import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeftIcon, EditIcon, MailIcon, PhoneIcon, MapPinIcon, PackageIcon, CalendarIcon, TrendingUpIcon } from 'lucide-react';
export function SupplierDetail() {
  const navigate = useNavigate();
  const {
    id
  } = useParams();
  // Mock data
  const supplier = {
    id: id,
    companyName: 'Premium Tea Estates Ltd',
    contactPerson: 'Rajesh Kumar',
    email: 'rajesh@premiumtea.lk',
    phone: '+94 77 123 4567',
    address: '123 Tea Estate Road, Nuwara Eliya, Sri Lanka',
    productsSupplied: 'Ceylon Black Tea, Green Tea, White Tea',
    paymentTerms: 'Net 30',
    status: 'Active',
    totalOrders: 45,
    totalValue: 'LKR 2,450,000',
    lastOrderDate: '2024-01-15',
    createdDate: '2023-06-10'
  };
  const recentOrders = [{
    id: 'PO-001',
    date: '2024-01-15',
    items: 'Ceylon Black Tea (500kg)',
    amount: 'LKR 125,000',
    status: 'Delivered'
  }, {
    id: 'PO-002',
    date: '2024-01-08',
    items: 'Green Tea (300kg)',
    amount: 'LKR 90,000',
    status: 'Delivered'
  }, {
    id: 'PO-003',
    date: '2023-12-28',
    items: 'White Tea (200kg)',
    amount: 'LKR 150,000',
    status: 'Delivered'
  }];
  return <div className="space-y-6" data-id="element-6306">
      {/* Header */}
      <div className="flex items-center justify-between" data-id="element-6307">
        <div className="flex items-center space-x-4" data-id="element-6308">
          <button onClick={() => navigate('/suppliers')} className="p-2 hover:bg-gray-100 rounded-md" data-id="element-6309">
            <ArrowLeftIcon size={20} data-id="element-6310" />
          </button>
          <div data-id="element-6311">
            <h2 className="text-2xl font-semibold text-gray-900" data-id="element-6312">
              {supplier.companyName}
            </h2>
            <p className="text-sm text-gray-500 mt-1" data-id="element-6313">Supplier Details</p>
          </div>
        </div>
        <button onClick={() => navigate(`/supplier-form?id=${id}`)} className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700" data-id="element-6314">
          <EditIcon size={18} className="mr-2" data-id="element-6315" />
          Edit Supplier
        </button>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-6316">
        {/* Left Column - Supplier Info */}
        <div className="lg:col-span-2 space-y-6" data-id="element-6317">
          {/* Contact Information */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-6318">
            <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-6319">
              Contact Information
            </h3>
            <div className="space-y-4" data-id="element-6320">
              <div className="flex items-start" data-id="element-6321">
                <MailIcon size={18} className="text-gray-400 mt-1 mr-3" data-id="element-6322" />
                <div data-id="element-6323">
                  <p className="text-sm text-gray-500" data-id="element-6324">Email</p>
                  <p className="text-sm font-medium text-gray-900" data-id="element-6325">
                    {supplier.email}
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-6326">
                <PhoneIcon size={18} className="text-gray-400 mt-1 mr-3" data-id="element-6327" />
                <div data-id="element-6328">
                  <p className="text-sm text-gray-500" data-id="element-6329">Phone</p>
                  <p className="text-sm font-medium text-gray-900" data-id="element-6330">
                    {supplier.phone}
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-6331">
                <MapPinIcon size={18} className="text-gray-400 mt-1 mr-3" data-id="element-6332" />
                <div data-id="element-6333">
                  <p className="text-sm text-gray-500" data-id="element-6334">Address</p>
                  <p className="text-sm font-medium text-gray-900" data-id="element-6335">
                    {supplier.address}
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-6336">
                <PackageIcon size={18} className="text-gray-400 mt-1 mr-3" data-id="element-6337" />
                <div data-id="element-6338">
                  <p className="text-sm text-gray-500" data-id="element-6339">Products Supplied</p>
                  <p className="text-sm font-medium text-gray-900" data-id="element-6340">
                    {supplier.productsSupplied}
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Recent Orders */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-6341">
            <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-6342">
              Recent Orders
            </h3>
            <div className="space-y-3" data-id="element-6343">
              {recentOrders.map(order => <div key={order.id} className="flex items-center justify-between p-4 border border-gray-200 rounded-md hover:bg-gray-50" data-id="element-6344">
                  <div className="flex-1" data-id="element-6345">
                    <div className="flex items-center space-x-3" data-id="element-6346">
                      <p className="text-sm font-medium text-gray-900" data-id="element-6347">
                        {order.id}
                      </p>
                      <span className={`px-2 py-1 text-xs font-semibold rounded-full ${order.status === 'Delivered' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'}`} data-id="element-6348">
                        {order.status}
                      </span>
                    </div>
                    <p className="text-sm text-gray-500 mt-1" data-id="element-6349">{order.items}</p>
                    <p className="text-xs text-gray-400 mt-1" data-id="element-6350">{order.date}</p>
                  </div>
                  <p className="text-sm font-medium text-gray-900" data-id="element-6351">
                    {order.amount}
                  </p>
                </div>)}
            </div>
          </div>
        </div>
        {/* Right Column - Stats */}
        <div className="space-y-6" data-id="element-6352">
          {/* Status */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-6353">
            <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-6354">Status</h3>
            <span className={`px-3 py-1 inline-flex text-sm font-semibold rounded-full ${supplier.status === 'Active' ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'}`} data-id="element-6355">
              {supplier.status}
            </span>
          </div>
          {/* Statistics */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-6356">
            <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-6357">
              Statistics
            </h3>
            <div className="space-y-4" data-id="element-6358">
              <div data-id="element-6359">
                <div className="flex items-center text-gray-500 text-sm mb-1" data-id="element-6360">
                  <TrendingUpIcon size={16} className="mr-2" data-id="element-6361" />
                  Total Orders
                </div>
                <p className="text-2xl font-semibold text-gray-900" data-id="element-6362">
                  {supplier.totalOrders}
                </p>
              </div>
              <div data-id="element-6363">
                <div className="flex items-center text-gray-500 text-sm mb-1" data-id="element-6364">
                  <TrendingUpIcon size={16} className="mr-2" data-id="element-6365" />
                  Total Value
                </div>
                <p className="text-2xl font-semibold text-gray-900" data-id="element-6366">
                  {supplier.totalValue}
                </p>
              </div>
              <div data-id="element-6367">
                <div className="flex items-center text-gray-500 text-sm mb-1" data-id="element-6368">
                  <CalendarIcon size={16} className="mr-2" data-id="element-6369" />
                  Last Order
                </div>
                <p className="text-sm font-medium text-gray-900" data-id="element-6370">
                  {supplier.lastOrderDate}
                </p>
              </div>
              <div data-id="element-6371">
                <div className="flex items-center text-gray-500 text-sm mb-1" data-id="element-6372">
                  <CalendarIcon size={16} className="mr-2" data-id="element-6373" />
                  Member Since
                </div>
                <p className="text-sm font-medium text-gray-900" data-id="element-6374">
                  {supplier.createdDate}
                </p>
              </div>
            </div>
          </div>
          {/* Payment Terms */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-6375">
            <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-6376">
              Payment Terms
            </h3>
            <p className="text-sm text-gray-900" data-id="element-6377">{supplier.paymentTerms}</p>
          </div>
        </div>
      </div>
    </div>;
}